import { destroy } from "@/application/api";

export const addressBookAddressDestroy = ({
  clientId,
  addressBookAddressId,
}: {
  clientId: number;
  addressBookAddressId: number;
}) => destroy(`client/${clientId}/address-book/${addressBookAddressId}`);
